import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

var organizationKind = localStorage.getItem('organizationKind');


export default new Router({
	mode: 'history',
	routes: [
		/* {
		    path: '/',
		    redirect: '/branchmgment',
		}, */
		{
			path: '/',
			component: () => import( /* webpackChunkName: "home" */ '../components/Layout'),
			meta: {
				title: '自述文件'
			},
			children: [{
					path: '/branchmgment',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/BranchMgment'),
					meta: {
						title: '分支机构管理'
					}
				},
				{
					path: '/headadmin',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/HeadAdmin'),
					meta: {
						title: '总部管理员管理'
					}
				},
				{
					path: '/manufacturerorganizations',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/ManufacturerOrganizations'),
					meta: {
						title: '厂商管理'
					}
				},
				{
					path: '/manufacturerbusinessperson',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/ManufacturerBusinessPerson'),
					meta: {
						title: '厂商业务员管理'
					}
				},
				{
					path: '/headbusinesspersons',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/HeadBusinessPersons'),
					meta: {
						title: '总部业务员管理'
					}
				},
				{
					path: '/licenseapplys/:activeName/:pageIndex',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/LicenseApplys'),
					meta: {
						title: '牌照查看'
					}
				}, //工程机械牌照申请
				{
					path: '/addlicense/:activeName/:pageIndex',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/licenseapplys/addLicense'),
					meta: {
						title: '牌照查看-总部添加证书'
					}
				}, //总部添加证书
				{
					path: '/alterlicense/:licenseApplyId',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/licenseapplys/alterLicense'),
					meta: {
						title: '牌照查看-查看修改证书'
					}
				}, //总部添加证书
				{
					path: '/fz_alterlicense/:licenseApplyId',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/licenseapplys/fz_alterLicense'),
					meta: {
						title: '牌照查看-查看修改证书'
					}
				}, //总部添加证书
				{
					name: 'examine',
					path: '/examine/:licenseApplyId',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/licenseRevise/examine'),
					meta: {
						title: '牌照查看-查看修改证书'
					}
				}, //分支机构审核中 -- 牌照审核 --修改   

				{
					path: '/seelicenseapplys/:licenseApplyId/:activeName/:pageIndex',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/licenseapplys/seeLicenseApplys'),
					meta: {
						title: '牌照查看-查看'
					}
				},
				{
					path: '/seeLicenseapplyszbjx/:licenseApplyId/:activeName/:pageIndex',
					name: 'seeLicenseapplyszbjx',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/licenseapplys/seeLicenseApplyszbjx'),
					meta: {
						title: '牌照查看-查看'
					}
				},
				{
					path: '/seeLicenseapplysfzorgan/:licenseApplyId/:pageIndex/:activeName',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/licenseapplys/seeLicenseApplysfzorgan'),
					meta: {
						title: '牌照查看-查看'
					}
				},
				{
					name: 'fz_seeLicenseapplysfzorgan',
					path: '/fz_seeLicenseapplysfzorgan/:licenseApplyId/:activeName/:pageIndex',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/licenseapplys/fz_seeLicenseApplysfzorgan'),
					meta: {
						title: '牌照查看-查看'
					}
				}, //分支机构查看分支机构牌照
				{
					name: 'historyDetail',
					path: '/historyDetail/:licenseApplyId/:activeName/:pageIndex',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/licenseapplys/historyDetail'),
					meta: {
						title: '分支机构记录详情'
					}
				}, //分支机构记录详情
				{
					path: '/licensecheckxcx/:activeName/:pageIndex',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/LicenseCheckXcx'),
					meta: {
						title: '小程序用户'
					}
				}, //工程机械牌照审核——小程序用户
				{
					path: '/seeLicensecheckxcxfirst/:licenseApplyId/:activeName/:pageIndex',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/licenseapplys/seeLicenseCheckXcxfirst'),
					meta: {
						title: '小程序用户-牌照审核查看'
					}
				}, //工程机械牌照审核——小程序用户——查看1
				{
					path: '/seeLicensecheckxcxsec/:mechanicsTransactionApplyId/:activeName/:pageIndex',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/licenseapplys/seeLicenseCheckXcxsec'),
					meta: {
						title: '小程序用户-车辆变更&车主变更审核查看'
					}
				}, //工程机械牌照审核——小程序用户——查看1


				{
					path: '/licensecheckfzorgan/:activeName/:pageIndex',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/LicenseCheckFzorgan'),
					meta: {
						title: '分支机构'
					}
				}, //工程机械牌照审核——分支机构
				{
					path: '/seelicensecheckfzorganfirst/:licenseApplyId/:activeName/:pageIndex',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/licenseapplys/seeLicenseCheckfzorganfirst'),
					meta: {
						title: '分支机构-牌照审核查看'
					}
				}, //
				{
					name: 'showfirst',
					path: '/showfirst/:licenseApplyId/:activeName/:pageIndex',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/licenseapplys/showfirst'),
					meta: {
						title: '分支-分支机构-牌照审核'
					}
				}, //
				{
					// path: '/seelicensecheckfzorgansec/:mechanicsTransactionApplyId',
					path: '/seelicensecheckfzorgansec/:mechanicsTransactionApplyId/:activeName/:pageIndex',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/licenseapplys/seeLicenseCheckfzorgansec'),
					meta: {
						title: '分支机构-车辆变更&车主变更审核查看'
					}
				}, //
				{
					path: '/showThird/:mechanicsTransactionApplyId/:activeName/:pageIndex',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/licenseapplys/showThird'),
					meta: {
						title: '分支机构-车辆变更&车主变更审核查看'
					}
				}, //
				{
					path: '/showSecond/:mechanicsTransactionApplyId/:activeName/:pageIndex',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/licenseapplys/showSecond'),
					meta: {
						title: '分支机构-车辆变更&车主变更审核查看'
					}
				}, //
				{
					path: '/seelicensecheckfzorganthird/:licenseApplyId/:activeName/:pageIndex',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/licenseapplys/seeLicenseCheckfzorganthird'),
					meta: {
						title: '分支机构-牌照修改审核查看'
					}
				}, //

				{
					path: '/licensecheckzbperson/:activeName/:pageIndex',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/LicenseCheckZbperson'),
					meta: {
						title: '总部业务员'
					}
				}, //工程机械牌照审核——总部业务员
				{
					path: '/seelicensecheckfzbfirst/:licenseApplyId/:activeName/:pageIndex',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/licenseapplys/seeLicenseCheckfzbfirst'),
					meta: {
						title: '总部业务员-牌照审核查看'
					}
				}, //
				{
					path: '/licensecheckjxshop/:activeName/:pageIndex',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/LicenseCheckJxshop'),
					meta: {
						title: '厂商业务员'
					}
				}, //工程机械牌照审核——机械厂商业务员


				{
					path: '/seelicensecheckjxfirst/:licenseApplyId/:activeName/:pageIndex',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/licenseapplys/seeLicenseCheckjxfirst'),
					meta: {
						title: '厂商业务员-牌照审核查看'
					}
				}, //
				{
					path: '/seelicensecheckjxsec/:mechanicsTransactionApplyId/:activeName/:pageIndex',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/licenseapplys/seeLicenseCheckjxsec'),
					meta: {
						title: '厂商业务员-车辆变更&车主变更审核查看'
					}
				}, //
				{
					path: '/seelicensecheckjxthird/:licenseApplyId/:activeName/:pageIndex',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/licenseapplys/seeLicenseCheckjxthird'),
					meta: {
						title: '厂商业务员-牌照修改审核查看'
					}
				}, //


				{
					path: '/certificateapplys/:ceractiveName/:pageIndex',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/CertificateApplys'),
					meta: {
						title: '操作证查看'
					}
				}, //工程机械操作证申请
				{
					path: '/cerapplyseefirst/:certificateApplyId/:ceractiveName/:pageIndex',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/certificateapplys/CerapplySeefirst'),
					meta: {
						title: '操作证查看-查看'
					}
				}, //工程机械操作证申请
				{
					path: '/cerapplyseesec/:certificateApplyId/:ceractiveName/:pageIndex',
					// path: '/cerapplyseesec/:certificateApplyId',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/certificateapplys/CerapplySeesec'),
					meta: {
						title: '操作证查看-查看'
					}
				}, //工程机械操作证申请
				{
					path: '/cerapplyseethird/:certificateApplyId/:ceractiveName/:pageIndex',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/certificateapplys/CerapplySeethird'),
					meta: {
						title: '操作证查看-查看'
					}
				}, //工程机械操作证申请

				{
					path: '/certificatecheckfzorgan/:activeName/:pageIndex',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/CertificateCheckFzorgan'),
					meta: {
						title: '分支机构'
					}
				}, //分支机构用户操作证书审核
				{
					path: '/certificatecheckxcx/:activeName/:pageIndex',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/CertificateCheckXcx'),
					meta: {
						title: '小程序用户'
					}
				}, //小程序用户操作证书审核
				{
					path: '/certificatecheckzbperson/:activeName/:pageIndex',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/CertificateCheckZbperson'),
					meta: {
						title: '总部业务员'
					}
				}, //总部业务员操作证书审核
				{
					path: '/certificatecheckjxshop/:checkactiveorgan/:pageIndex',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/CertificateCheckJxshop'),
					meta: {
						title: '厂商业务员'
					}
				}, //机械厂商业务员证书审核 
				{
					path: '/cercheckseefirst/:certificateApplyId/:activeName/:pageIndex',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/certificateapplys/CercheckSeefirst'),
					meta: {
						title: '操作证审核-小程序用户查看'
					}
				}, //审核--查看
				{
					path: '/cercheckseesec/:certificateTimeexpandApplyId/:activeName/:pageIndex',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/certificateapplys/CercheckSeesec'),
					meta: {
						title: '操作证审核-小程序用户证书到期换证查看'
					}
				}, //审核--查看
				{
					path: '/cercheckseefzorganfirst/:certificateApplyId/:activeName/:pageIndex',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/certificateapplys/CercheckSeefzorganfirst'),
					meta: {
						title: '操作证审核-分支机构查看'
					}
				}, //审核--查看
				{
					path: '/operationfirst/:certificateApplyId/:activeName/:pageIndex',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/certificateapplys/operationfirst'),
					meta: {
						title: '操作证审核-分支机构查看'
					}
				}, //操作证审核中--查看
				{
					path: '/cercheckseefzorgansec/:certificateTimeexpandApplyId',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/certificateapplys/CercheckSeefzorgansec'),
					meta: {
						title: '操作证审核-分支机构证书到期换证查看'
					}
				}, //审核--查看
				{
					path: '/operationsecond/:certificateApplyId/:activeName/:pageIndex',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/certificateapplys/operationsecond'),
					meta: {
						title: '操作证审核-分支机构查看'
					}
				}, //操作证审核中--查看
				{
					path: '/cercheckseefzbfirst/:certificateApplyId/:checkactiveorgan/:pageIndex',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/certificateapplys/CercheckSeefzbfirst'),
					meta: {
						title: '操作证审核-总部业务员查看'
					}
				}, //审核--查看
				{
					path: '/cercheckseefzbsec/:certificateTimeexpandApplyId/:checkactiveorgan/:pageIndex',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/certificateapplys/CercheckSeefzbsec'),
					meta: {
						title: '操作证审核-总部业务员操作证书到期换证查看'
					}
				}, //审核--查看
				{
					path: '/cercheckseefjxfirst/:certificateApplyId/:checkactiveorgan/:pageIndex',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/certificateapplys/CercheckSeefjxfirst'),
					meta: {
						title: '操作证审核-厂商业务员查看'
					}
				}, //审核--查看
				{
					path: '/cercheckseefjxsec/:certificateTimeexpandApplyId/:checkactiveorgan/:pageIndex',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/certificateapplys/CercheckSeefjxsec'),
					meta: {
						title: '操作证审核-厂商业务员操作证书到期换证查看'
					}
				}, //审核--查看
				{
					path: '/orderlicense',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/Orderlicense'),
					meta: {
						title: '牌照预约'
					}
				}, //预约信息-牌照预约
				{
					path: '/ordercertificate',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/Ordercertificate'),
					meta: {
						title: '证书预约'
					}
				}, //预约信息-证书预约
				{
					path: '/consults',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/Consults'),
					meta: {
						title: '资讯管理'
					}
				},
				{
					// 添加页面
					path: '/consultsadd',
					component: () => import( /* webpackChunkName: "editor" */ '../views/consults/ConsultsAdd.vue'),
					meta: {
						title: '资讯管理-添加'
					}
				},
				{
					// 查看页面
					path: '/consultsee/:consultId',
					component: () => import( /* webpackChunkName: "editor" */ '../views/consults/ConsultsSee.vue'),
					meta: {
						title: '资讯管理-查看'
					}
				},
				{
					// 编辑页面
					path: '/consultsedit/:consultId',
					component: () => import( /* webpackChunkName: "editor" */ '../views/consults/ConsultsEdit.vue'),
					meta: {
						title: '资讯管理-编辑'
					}
				},

				{
					path: '/articles',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/Articles'),
					meta: {
						title: '学习资料管理'
					}
				},
				{
					// 添加页面
					path: '/articlesadd',
					component: () => import( /* webpackChunkName: "editor" */ '../views/articles/ArticlesAdd.vue'),
					meta: {
						title: '学习资料管理-添加'
					}
				},
				{
					// 查看页面
					path: '/articlessee/:articleId',
					component: () => import( /* webpackChunkName: "editor" */ '../views/articles/ArticlesSee.vue'),
					meta: {
						title: '学习资料管理-查看'
					}
				},
				{
					// 编辑页面
					path: '/articlesedit/:articleId',
					component: () => import( /* webpackChunkName: "editor" */ '../views/articles/ArticlesEdit.vue'),
					meta: {
						title: '学习资料管理-修改'
					}
				},
				{
					path: '/questions',
					component: () => import( /* webpackChunkName: "editor" */ '../views/Questions.vue'),
					meta: {
						title: '证书考试内容管理'
					}
				},

				{
					path: '/organizationlicenseapply',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/OrganizationLicenseApply'),
					meta: {
						title: '牌证申请审批'
					}
				},
				{
					// 查看页面
					path: '/seeorganlicenseapply/:organizationLicenseApplyId',
					component: () => import( /* webpackChunkName: "editor" */ '../views/organizationlicenseapply/seeOrganizationLicenseApply'),
					meta: {
						title: '牌证申请审批-查看'
					}
				},
				{
					// 查看页面
					path: '/organizationapplicationlook',
					component: () => import( /* webpackChunkName: "editor" */ '../views/OrganizationApplicationLook'),
					meta: {
						title: '牌照申请历史'
					}
				},
				{
					// 查看页面
					path: '/seefzorganLook/:organizationLicenseApplyId',
					component: () => import( /* webpackChunkName: "editor" */ '../views/organizationapplicationlook/seeFzorganLook'),
					meta: {
						title: '牌照申请历史'
					}
				},
				{
					// 查看页面
					path: '/seeorganizationapplicationlook/:organizationLicenseApplyId',
					component: () => import( /* webpackChunkName: "editor" */ '../views/organizationapplicationlook/seeOrganizationApplicationLook'),
					meta: {
						title: '牌照申请历史-查看'
					}
				},

				{
					path: '/licencerelation',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/LicenceRelation'),
					meta: {
						title: '牌照关系维护'
					}
				},
				{
					path: '/livingdemands',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/LivingDemands'),
					meta: {
						title: '货源信息管理'
					}
				},
				{
					path: '/usedcars',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/UsedCars'),
					meta: {
						title: '二手车信息管理'
					}
				},
				{
					path: '/addbatchcer',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/addBatchCer'),
					meta: {
						title: '批量添加证书'
					}
				},
				{
					path: '/remandmessage',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/remandMessage'),
					meta: {
						title: '分支机构管理'
					}
				},

				//分支机构菜单路由
				{
					path: '/fzorganadmin',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/FzorganAdmin'),
					meta: {
						title: '分支机构业务员管理'
					}
				}, //分支机构菜单
				{
					// path: '/fzorganlicenseapplys',
					path: '/fzorganlicenseapplys/:activeName/:pageIndex',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/FzorganLicenseApplys'),
					meta: {
						title: '牌照查看'
					}
				}, //分支机构菜单
				{
					path: '/fzorganhistory/:activeName/:pageIndex',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/fzorganhistory'),
					meta: {
						title: '牌照审核中'
					}
				},
				{
					path: '/operationhistory/:activeName/:pageIndex',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/operationhistory'),
					meta: {
						title: '操作证审核中'
					}
				},
				{
					path: '/addfblicense',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/licenseapplys/addfbLicense'),
					meta: {
						title: '牌照查看/添加牌照'
					}
				}, //分支机构菜单
				{
					path: '/fzorgancertificateapplys/:ceractiveName/:pageIndex',
					// path: '/fzorgancertificateapplys/',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/FzorganCertificateApplys'),
					meta: {
						title: '操作证书查看'
					}
				}, //分支机构菜单

				{
					path: '/fzorganapplicationlook',
					component: () => import( /* webpackChunkName: "editor" */ '../views/FzorganApplicationLook'),
					meta: {
						title: '牌证申请历史'
					}
				}, //分支机构菜单
				{
					// 查看页面
					path: '/seefzorganlicenseapply/:organizationLicenseApplyId',
					component: () => import( /* webpackChunkName: "editor" */ '../views/organizationlicenseapply/seeFzorganLicenseApply'),
					meta: {
						title: '牌证申请历史-查看'
					}
				},

				// 模拟路由

				{
					path: '/dashboard',
					component: () => import( /* webpackChunkName: "dashboard" */ '../views/Dashboard'),
					meta: {
						title: '系统首页'
					}
				},
				{
					path: '/icon',
					component: () => import( /* webpackChunkName: "icon" */ '../views/Icon.vue'),
					meta: {
						title: '自定义图标'
					}
				},
				{
					path: '/table',
					component: () => import( /* webpackChunkName: "table" */ '../views/BaseTable.vue'),
					meta: {
						title: '基础表格'
					}
				},
				{
					path: '/tabs',
					component: () => import( /* webpackChunkName: "tabs" */ '../views/Tabs.vue'),
					meta: {
						title: 'tab选项卡'
					}
				},
				{
					path: '/form',
					component: () => import( /* webpackChunkName: "form" */ '../views/BaseForm.vue'),
					meta: {
						title: '基本表单'
					}
				},
				{
					// 富文本编辑器组件
					path: '/editor',
					component: () => import( /* webpackChunkName: "editor" */ '../views/VueEditor.vue'),
					meta: {
						title: '富文本编辑器'
					}
				},
				{
					// markdown组件
					path: '/markdown',
					component: () => import( /* webpackChunkName: "markdown" */ '../views/Markdown.vue'),
					meta: {
						title: 'markdown编辑器'
					}
				},
				{
					// 图片上传组件
					path: '/upload',
					component: () => import( /* webpackChunkName: "upload" */ '../views/Upload.vue'),
					meta: {
						title: '文件上传'
					}
				},
				{
					// 图片裁剪测试
					path: '/testImg',
					component: () => import( /* webpackChunkName: "upload" */ '../views/testImg.vue'),
					meta: {
						title: '图片裁剪测试'
					}
				},
				{
					// vue-schart组件
					path: '/charts',
					component: () => import( /* webpackChunkName: "chart" */ '../views/BaseCharts.vue'),
					meta: {
						title: 'schart图表'
					}
				},
				{
					// 拖拽列表组件
					path: '/drag',
					component: () => import( /* webpackChunkName: "drag" */ '../views/DragList.vue'),
					meta: {
						title: '拖拽列表'
					}
				},
				{
					// 拖拽Dialog组件
					path: '/dialog',
					component: () => import( /* webpackChunkName: "dragdialog" */ '../views/DragDialog.vue'),
					meta: {
						title: '拖拽弹框'
					}
				},
				{
					// 国际化组件
					path: '/i18n',
					component: () => import( /* webpackChunkName: "i18n" */ '../views/I18n.vue'),
					meta: {
						title: '国际化'
					}
				},
				{
					// 权限页面
					path: '/permission',
					component: () => import( /* webpackChunkName: "permission" */ '../views/Permission.vue'),
					meta: {
						title: '权限测试',
						permission: true
					}
				},
				{
					path: '/404',
					component: () => import( /* webpackChunkName: "404" */ '../views/404.vue'),
					meta: {
						title: '404'
					}
				},
				{
					path: '/403',
					component: () => import( /* webpackChunkName: "403" */ '../views/403.vue'),
					meta: {
						title: '403'
					}
				},
				{
					path: '/donate',
					component: () => import( /* webpackChunkName: "donate" */ '../views/Donate.vue'),
					meta: {
						title: '支持作者'
					}
				},{
				path: '/indexEcharts',
				component: () => import( /* webpackChunkName: "home" */ '../views/IndexEcharts'),
				meta: {
					title: '统计图表'
				}
			},
			]
		},
		{
			path: '/login',
			component: () => import( /* webpackChunkName: "login" */ '../views/Login.vue'),
			meta: {
				title: '登录'
			}
		},
		{
			path: '*',
			redirect: '/404'
		}
	]
});